import React from 'react';
import { LoadingIndicatorProgress } from '@ohif/ui-next';

function EmptyViewport() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-black">
      <LoadingIndicatorProgress className="bg-black/80" />
    </div>
  );
}

export default EmptyViewport;
